import React from 'react';

//0 pendiente
//1 realizado
const EstadoCita = ( props ) => {
  //console.log("props");
  //console.log(props);
  let valor = parseInt(props.value)
  return (
    <div>
       {(() => {
        switch (valor) {
          case 0:
            return <span className="badge badge-primary">No confirmado</span>
          case 1:
            return <span className="badge badge-warning">Confirmado</span>
          case 2:
            return <span className="badge badge-danger">Hora cancelada</span>
          case 3:
            return <span className="badge badge-success">Atendido</span>
          default:
            return null
        }
      })()}
    </div>
  );
};

//-------------------------------------

export default (EstadoCita);
